/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react/no-unstable-nested-components */
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import BenefitsCart, { ReactComponent as BenefitsCartIcon } from 'src/assets/benefits-cart.svg';
import { ReactComponent as BenefitsAvailableIcon } from 'src/assets/benefits-available.svg';

import { FullScreenLoading } from 'pg-ui-library';
import { useTypedSelector } from 'src/hooks/useTypedSelector';

import { useActions } from 'src/hooks/useActions';
import { monetaryUSDFormat } from 'src/utils/currencyFormat';

import {
  Container,
  Header,
  HeaderTitle,
  Content,
  HeaderItemLeft,
  HeaderItemRight,
  CancelButton,
  ScrollableContainer,
  ScrollableContainerEmpty,
  CartFooter,
  CartFooterText,
  CartContainer,
  LeftGridContent,
  RightGridContent,
} from './styles';
import AvailableBenefitsCard from '../available-benefits-card';
import EnrollmentChanges from '../enrollment-changes';
import CartTabs from '../cart-tabs';

import { EnrollSelectionModal } from '../enroll-selection-modal';
import { StoreContextProvider, useBenefitEnrollSelectionModalIsOpen, useQle } from '../../enrollment.context';
import { BenefitEventType, benefitsCategories } from '../..';

import ConfirmEmptyModal from '../confirm-empty-documents-modal';
import AddressTable from '../address-table';
import ContactsTable from '../contacts-table';
import { EnrollmentSteps, EnrollmentWizard } from '../enrollment-wizard';

const RetirmentLifestyleWrapper: React.FC = () => (
  <EnrollmentChanges categories={[benefitsCategories[2]]} enabledHeader={false} eventType="update_enrollment" />
);

const UpdateEnrollmentEvent: React.FC = () => {
  const updateEnrollmentSteps: EnrollmentSteps[] = [
    {
      title: 'Step 1:',
      subtitle: 'Address',
      content: <AddressTable />,
      available: true,
    },
    {
      title: 'Step 2:',
      subtitle: 'Contacts Information',
      content: <ContactsTable />,
      available: true,
    },
    {
      title: 'Step 3:',
      subtitle: 'Retirement & Lifestyle',
      content: <RetirmentLifestyleWrapper />,
      available: true,
    },
  ];

  const isOpen = useBenefitEnrollSelectionModalIsOpen();

  const { t } = useTranslation();
  const { getPersonalInfo, getCartSession, setBenefitEnrollmentType } = useActions();
  const [confirmEmptySubmit, setConfirmEmptySubmit] = useState(false);

  const qle = useQle();

  const { loading } = useTypedSelector(state => state.benefits);
  const { cart, benefits, fetchingCartSession } = useTypedSelector(state => state.benefits.data);
  const isEmpty = cart ? cart?.length <= 0 : true;

  const totalAddedToCart = cart
    ?.filter(benefit => benefit.action === 'ADD')
    ?.map(benefit => benefit.price)
    .reduce((acc, next) => Number(acc) + Number(next), 0) as unknown as 0;

  const navigate = useNavigate();

  useEffect(() => {
    setBenefitEnrollmentType(BenefitEventType.UPDATE_ENROLLMENT);
    getPersonalInfo();
    getCartSession(BenefitEventType.UPDATE_ENROLLMENT);
  }, []);

  const startReview = () => {
    const stateData = { event: BenefitEventType.UPDATE_ENROLLMENT, qle };

    navigate('/benefits/qle-review', { state: stateData });
  };

  const validateEmptySubmit = () => {
    startReview();
  };

  return (
    <Container>
      {(loading || fetchingCartSession) && <FullScreenLoading />}
      <Header>
        <HeaderItemLeft>
          <HeaderTitle>{t('benefits.updateEnrollment.title')}</HeaderTitle>
        </HeaderItemLeft>
        <HeaderItemRight>
          <CancelButton onClick={() => navigate('/benefits', { replace: true })}>
            {t('global.form.cancel')}
          </CancelButton>
        </HeaderItemRight>
      </Header>
      <Content>
        <LeftGridContent>
          <EnrollmentWizard
            steps={updateEnrollmentSteps}
            submit={validateEmptySubmit}
            reviewEnabled={qle?.isEventInEligiblePeriod}
          />
          {isOpen && <EnrollSelectionModal eventType={BenefitEventType.UPDATE_ENROLLMENT} />}
        </LeftGridContent>
        <RightGridContent>
          <CartTabs
            firstTabTitle="Active"
            FirstTabIcon={BenefitsAvailableIcon}
            secondTabTitle="Cart"
            SecondTabIcon={BenefitsCartIcon}
            FirstTabContent={() => (
              <ScrollableContainer>
                {benefits.map((benefit, index) => (
                  <AvailableBenefitsCard
                    // eslint-disable-next-line react/no-array-index-key
                    key={index}
                    benefitId={benefit.benefitId}
                    imgURL={benefit.imgURL}
                    title={benefit.benefitName}
                    subtitle={
                      benefit.dependentsDescription
                        ? benefit.dependentsDescription
                        : benefit.optionDescription || benefit.benefitOptionId
                    }
                    fee={monetaryUSDFormat(benefit.fixedAmount || benefit.employeeCost)}
                    date={benefit.benefitEnrollmentEnd}
                    editMode={false}
                    deleteMode={false}
                  />
                ))}
              </ScrollableContainer>
            )}
            SecondTabContent={() => (
              <>
                {isEmpty ? (
                  <ScrollableContainerEmpty>
                    <img src={BenefitsCart} />
                    <h3 style={{ margin: 0 }}>{t('benefits.updateEnrollment.emptyCart.line1')}</h3>
                    <p style={{ margin: 0 }}>{t('benefits.updateEnrollment.emptyCart.line2')}</p>
                    <p style={{ margin: 0 }}>{t('benefits.updateEnrollment.emptyCart.line3')}</p>
                  </ScrollableContainerEmpty>
                ) : (
                  <CartContainer>
                    <ScrollableContainer>
                      {cart?.map((benefit, index) => (
                        <AvailableBenefitsCard
                          // eslint-disable-next-line react/no-array-index-key
                          key={index}
                          type={benefit.type}
                          benefitId={benefit.benefitId}
                          imgURL={benefit.imgURL}
                          title={benefit.planDescription}
                          subtitle={
                            benefit.dependentsDescription ? benefit.dependentsDescription : benefit.optionDescription
                          }
                          fee={monetaryUSDFormat(benefit.price)}
                          date={benefit.expiration}
                          editMode={benefit.costCalculationMethod?.toLowerCase() !== 'free'}
                          deleteMode={benefit.costCalculationMethod?.toLowerCase() !== 'free'}
                          mandatory={false}
                          event="update-enrollment"
                        />
                      ))}
                    </ScrollableContainer>
                    <CartFooter>
                      <CartFooterText>
                        {t('benefits.newHire.totalOnCart')}:{monetaryUSDFormat(totalAddedToCart ?? 0)}
                      </CartFooterText>
                    </CartFooter>
                  </CartContainer>
                )}
              </>
            )}
          />

          <ConfirmEmptyModal isOpen={confirmEmptySubmit} setConfirmEmptySubmit={setConfirmEmptySubmit} />
        </RightGridContent>
      </Content>
    </Container>
  );
};

const UpdateEnrollmentEventStoreWrapper: React.FC = () => (
  <StoreContextProvider>
    <UpdateEnrollmentEvent />
  </StoreContextProvider>
);
export default UpdateEnrollmentEventStoreWrapper;
